'use strict';

/**
 * Identity sign up form
 */
const signUp =
	`<div class="sign-up-form p-5">
	    <h1 class="card-title text-center mb-5">Sign Up</h1>
	    <button class="btn btn-secondary-google w-100">Google</button>
	    <div class="stripe-line text-center w-75 mx-auto my-4"> or </div>
	    <form id="identity-signUp">
	        <div class="form-group">
	            <label for="username" class="text-uppercase">Username/Email</label>
	            <input type="text" class="form-control" id="username" placeholder="Enter username or email">
	            <div class="invalid-feedback username-feedback this"><strong>Shmoop</strong> <span>Fresh</span></div>
	        </div>
	        <div class="form-group">
	            <label for="password" class="text-uppercase">Password</label>
	            <div class="input-group password-eye">
	                <input type="password" class="form-control" id="password" placeholder="Password">
	                <div class="input-group-append">
	                    <div class="input-group-text">
	                        <i class="fas fa-eye reveal-password"></i>
	                        <i class="fas fa-eye-slash cloak-password d-none"></i>
	                    </div>
	                </div>
	                <div class="invalid-feedback password-feedback this">
	                	<strong>Shmoop</strong> <span>Fresh</span>
	                </div>	     
	            </div>	                   
	        </div>
	        <div class="position-relative">
	        <i class="fas fa-spinner fa-spin spinning-spinner d-none"></i>
	<button name="signUp-button" type="submit" class="btn btn-secondary mx-auto w-100 sign-up-button">Sign in</button>
	        </div>	        
	    </form>
	</div>`;

module.exports = {
	signUp: signUp
};
